export default __webpack_public_path__ + "static/media/skyrise.4311dbc6.png";